import React from 'react';

import './TopMenu.scss';
import BetsiteTopMenu from './components/BetsiteTopMenu';
import TillTopMenu from './components/TillTopMenu';

interface TopMenuProps {
  children?: React.ReactNode,
}

function TopMenu({ children }: TopMenuProps) {

  return (
    <nav className="top-menu">
      <div className="top-menu__list">
        { children }
      </div>
    </nav>
  );
}

TopMenu.Betsite = BetsiteTopMenu;
TopMenu.Till = TillTopMenu;

export default TopMenu;
